import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { documentApi } from 'api/main';
import { notificationCreated } from 'reducers/appNotification';
import { downloadClick, getDocumentName } from 'utils/helpers';

import { Loader } from 'components';
import { Typography } from '@mui/material';

const DocumentTitle = ({
    doc,
    fullName,
    belongsToCoSubscriber,
    boldName,
    uploadedFile,
    replaceLoading,
    isAudit,
    mimeType,
}) => {
    const dispatch = useDispatch();
    const [downloadingDoc, setDownloadingDoc] = useState(null);

    const handleDownload = useCallback(() => {
        if (!doc.id && doc.url) {
            downloadClick(doc.url);
            return;
        }
        setDownloadingDoc(doc.id);
        documentApi
            .downloadDocumentById(doc.id, isAudit)
            .then(response => {
                const bytes = new Uint8Array(response.data);
                const blob = new Blob([bytes], { type: doc.mimeType || mimeType });
                const url = window.URL.createObjectURL(blob);
                if (
                    doc.mimeType?.includes('application/vnd.openxmlformats-officedocument.word') ||
                    mimeType?.includes('application/vnd.openxmlformats-officedocument.word')
                ) {
                    downloadClick(url, doc.name, true, false);
                } else {
                    downloadClick(url);
                }
                setDownloadingDoc(null);
            })
            .catch(() => {
                dispatch(notificationCreated('FAILED_DOCUMENT_DOWNLOAD'));
                setDownloadingDoc(null);
            });
    }, [doc, mimeType, isAudit, dispatch]);

    return (
        <Loader loading={!!downloadingDoc} size={15} marginTop={0}>
            <Typography
                key={doc.id || doc.subtype || doc.type}
                sx={{
                    cursor: doc.id ? 'pointer' : 'default',
                    '&:hover': {
                        textDecoration: doc.id ? 'underline' : 'none',
                    },
                    fontWeight: boldName ? '600' : 'inherit',
                    flexBasis: uploadedFile && !replaceLoading ? '50%' : 'auto',
                    marginBottom: uploadedFile && !replaceLoading ? '5px' : 0,
                }}
                onClick={replaceLoading || !doc.id ? undefined : handleDownload}
                component="span"
            >
                {getDocumentName(doc, fullName, belongsToCoSubscriber)}
            </Typography>
        </Loader>
    );
};

DocumentTitle.propTypes = {
    doc: PropTypes.object,
    fullName: PropTypes.string,
    belongsToCoSubscriber: PropTypes.bool,
    boldName: PropTypes.bool,
    uploadedFile: PropTypes.object,
    replaceLoading: PropTypes.bool,
    isAudit: PropTypes.bool,
    mimeType: PropTypes.string,
};

export default DocumentTitle;
